import React from 'react'
import StyledLi from './styles'

interface IProps {
  label: string
  onClick: () => void
  isHidden: boolean
}

export const Option: React.FC<IProps> = ({ label, onClick, isHidden }) => {
  const handleClick = (event: any) => {
    event.stopPropagation()
    onClick()
  }

  if (isHidden) return null
  return (
    <StyledLi className="option" onClick={ handleClick }>
      <span className="label">{ label }</span>
    </StyledLi>
  )
}
